/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Helpers.PartialNameValidator = class PartialNameValidator {
  constructor(partialName, minLength) {
    this.partialName = partialName;
    if (minLength == null) { minLength = 2; }
    this.minLength = minLength;
  }

  isValid() {
    const stripped = $.trim(this.partialName);
    return stripped.length >= this.minLength;
  }
};
